<template>
  <section>
    <div class="about">
      <div class="aboutUs">
        <div class="aboutUsDetail">
          <!--<ul>-->
            <!--<li><a href="javascript:void(0)" >关于我们</a></li>-->
            <!--<li><a href="javascript:void(0)" @click="gotonews()">公司简介</a></li>-->
            <!--<li><a href="javascript:void(0)" @click="gotonews()">发展历程</a></li>-->
            <!--<li><a href="javascript:void(0)" @click="gotonews()">联系我们</a></li>-->
            <!--<li><a href="javascript:void(0)" @click="gotonews()">媒体报道</a></li>-->
          <!--</ul>-->
          <!--<ul>-->
            <!--<li><a href="javascript:void(0)" @click="gotonews()">新闻资讯</a></li>-->
            <!--<li><a href="javascript:void(0)" @click="gotonews()">公司公告</a></li>-->
            <!--<li><a href="javascript:void(0)" @click="gotonews()">常见问题</a></li>-->
            <!--<li><a href="javascript:void(0)" @click="gotonews()">行业动态</a></li>-->
            <!--<li><a href="javascript:void(0)" @click="gotonews()">SEO干货</a></li>-->
          <!--</ul>-->
          <ul v-for="item in list"
              :key='item.id' v-if='list.length>0'>
            <li><a href="javascript:void(0)" >{{item.name}}</a></li>
            <li  v-for='childItem in item.childlist' :key='childItem.id'>
              <a href="javascript:void(0)" @click="gotonews(childItem.id)">{{childItem.name}}</a></li>
            <li v-if=" item.name=='关于我们' "><a href="javascript:void (0)" @click="gotolink">联系我们</a></li>
          </ul>
          <ul>
            <li><a href="javascript:void(0)" >产品服务</a></li>
            <li><a  href="javascript:void(0)" @click="goop()">关键词优化</a></li>
            <li><a href="javascript:void(0)" @click="gopm()">快速排名</a></li>
            <!--<li><a href="javascript:void(0)" @click="goseo()">SEO优化</a></li>-->
            <li><a href="javascript:void(0)" @click="gozh()">整站优化</a></li>
          </ul>

          <ul>
            <li><a href="javascript:void(0)"  >福利政策</a></li>
            <li><a href="javascript:void(0)" @click="gourl('/dashboard/caiwuManagement/recharge')" >消费全返</a></li>
            <li><a href="javascript:void(0)" @click="gourl('/dashboard/reward')" >邀请奖励</a></li>
            <li><a href="javascript:void(0)" @click="gourl('/dashboard/apply')" >代理加盟</a></li>
          </ul>
        </div>
        <div class="aboutLine"></div>
        <div class="aboutDetail">
          <div class="aboutLogin"><img src="../assets/images/logo6.png" width="150"></div>
          <div class="aboutText">
            <!--<p>1.专注SEO技术十二年，通过技术驱动30多万家合作企业快速发展！ 自主研发智能SEO优化系统，易操作，优化快，上词快，效果好。智能优化监控系统，实时监控，优化，监控，调整，再优化，保证自主优化良性循环。</p>
            <p>2、积分优化选择要做的搜索引擎进行关键词提交。</p>
            <p>3、输入关键词要用英文的逗号隔开，一次最多可以提交50个关键词。</p>
            <p>4、积分是钱的代名词，一倍率是一元的意思。</p>
            <p>5、如排名显示在不能优化说明要做的关键词在百名外，百名外的关键词到首页的周期需要30天左右。</p>
            <p>6、网站定期更新内容配合积分优化，更有利于排名快速提升。</p>-->
<p>江苏沃媒网络科技有限公司成立于2016年，江苏省名牌企业，高新科技企业。2020年，沃媒网4周年之际，面向AI智能营销推广时代，创立了“爱排名”产品。爱排名技术团队专研SEO技术十年,自主研发AI智能网站排名优化系统,对百度、360、搜狗等搜索引擎关键词排名先达标后扣费！系统操作简单，只需要添加网址和关键词的一步操作就能坐等快速排名效果！使您的网站优化省时、省事、更省钱！目前系统关键词排名达标词30万+,智能监控系统让关键词排名效果以及费用消耗一目了然。爱排名拥有八项软件著作权，超过2000台服务器，技术团队超80多人,利用大数据分析+AI人工智能，打造出四大SAAS级云产品：快速排名、SEO优化、积分优化、整站优化。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="bottomImg"><img src="../assets/images/bottom.png" width="725" height="38"></div>
      <div class="bottomText">
        <!--<p>@2008-2018 江苏八五八网络科技有限公司版权所有.诉ICP备17130595号-3</p>-->
        <!--<p>《中华人民共和国增值电信业务经营许可证》编号：速B2-20170249号  &nbsp;&nbsp;ICP证：速ICP备14008752号</p>-->
        <p>{{beian}}<img style="width: 15px;height: 15px;margin-bottom: -2px"
                         src="../assets/images/gongan.png">苏公网安备 12011402001005号 苏ICP备16008797号-1</p>
      </div>
      <div style="height: 82px">

      </div>
      <div class="foorerModal" style="justify-content: center">
        <el-input v-model='userName' style="width: 20%" placeholder="姓名"></el-input>
        <el-input v-model='phone' style="width: 20%"  placeholder="手机号"></el-input>
        <p @click='addMessage' style="width: 10%">
          快速获取价值5000元<br>
          诊断SEO诊断报告
        </p>
      </div>
    </div>
  </section>
</template>
<script>
  import { Message } from 'element-ui';
  import { Api } from '../service/api';
  export default{
    name: 'BottomFooter',
    data() {
      return {
        business_name: '',      // 公司名称
        beian: '',      // 备案号
        userName: '',
        phone: '',
          list : [],
      }
    },
    methods: {
      setSite() {
        let params = {

        }
        Api.setSite(params).then((res) => {
          this.logo = res.data.data.logo;               // 网站logo
          this.beian = res.data.data.beian;               // 备案号
          this.business_name = res.data.data.business_name;      // 公司名称
          this.business_address = res.data.data.business_address;   // 公司地址
          this.free_hotline = res.data.data.free_hotline;       // 	免费热线
          this.fax = res.data.data.fax;                // 	传真
          this.qq = res.data.data.qq;                 // 官方qq
          this.weixin = res.data.data.weixin;            // 官方微信
          this.wximage = res.data.data.wximage;            // 微信扫码咨询
          this.qqimage = res.data.data.qqimage;            // 	qq扫码咨询
        })
      },
        gourl(path){
            this.$router.push({
                path: path
            })
        },
        gotolink(){
            this.$router.push({
                path: '/index/aboutUs'
            })
        },
        getArticleCategory () {
            let  params = {

            }
            Api.getArticleCategory(params).then((res)=> {
                for(let m=0; m<res.data.data.length;m++){
                    for(let n=0; n<res.data.data[m].childlist.length; n++){
                        res.data.data[m].childlist[n].active = false
                    }
                }
                this.list = res.data.data
            })
        },
        goop(){
            this.$router.push({
                path: '/dashboard/optimizeManagement/integrationOptimize'
            })
        },
        gopm(){
            this.$router.push({
                path: '/dashboard/optimizeManagement/quickRanking'
            })
        },
        goseo(){
            this.$router.push({
                path: '/dashboard/optimizeManagement/SEOOptimize'
            })
        },
        gozh(){
            this.$router.push({
                path: '/dashboard/optimizeManagement/webOptimize'
            })
        },
        gotonews(id){

            if(id==19){
                eventBus.$emit('articleDetail',12)
                this.$router.push({
                    path: '/index/articleList/'+12
                })

            }else if(id==20){
               eventBus.$emit('articleDetail',1)
                this.$router.push({
                    path: '/index/articleList/'+1
                })

            }else if(id==27){
              eventBus.$emit('articleDetail',16)
                this.$router.push({
                    path: '/index/articleList/'+16
                })

            }else {
               eventBus.$emit('getArticlePid',id)

                this.$router.push({
                    path: '/index/articleList/'+id
                })
            }

        },

      addMessage() {
        if(!this.userName){
          Message({
            showClose: true,
            message: '请填写姓名',
            type: 'success'
          })
          return
        }
        if(!(/^1[0123456789]\d{9}$/.test(this.phone))){
          Message({
            showClose: true,
            message: '请填写正确的手机号码',
            type: 'success'
          })
          return
        }
        let params = {
          name: this.userName,
          mobile: this.phone
        }
        Api.addMessage(params).then((res) => {
          Message({
            showClose: true,
            message: res.data.msg,
            type: 'success'
          })
        })
      }
    },
    mounted() {
        this.getArticleCategory()
        this.setSite()
      }
  }
</script>
<style lang='scss' scoped>
  section{
    background: #e7e7e7;

    .about{
      width: 100%;
      background: rgba(33,35,47,1);
      opacity: 1;
      p{
        text-align: justify;
      }
      .aboutText{
        p{
          text-align: justify;
        }
      }
      .aboutUs {

        padding: 24px 2.5rem;
        display: flex;
        .aboutUsDetail {
          width: 46%;
          display: flex;
          border-right: 1px solid #333232;
          justify-content: space-between;
          padding-right: 30px;
          ul{
            li{
              line-height: 30px;
              a{
                color: #aaa;
                font-size: 12px;
                &:hover{
                  color: #fc5f35;
                }
              }
              &:nth-of-type(1){
                a{
                  color: #fff;
                  font-size: 15px;

                }
              }
            }
          }
        }
        .aboutDetail{
          width: 46%;
          margin-left: 40px;
          text-align: left;
          font-size: 12px;
          color: #aaa;
          line-height: 18px;
          .aboutLogin{
            margin-bottom: 5px;
          }
          img{

          }
        }
      }
    }
    .bottom{
      width: 100%;
      height: 130px;
      background: rgba(33,35,47,1);
      opacity: 1;
      border-top: 1px solid rgba(112,112,112,0.2);
      color: #aaa;
      font-size:12px;
      position: relative;
      left: 0;
      top: 0;
      .bottomImg {
        width: 725px;
        height: 38px;
        margin: auto;
        margin-top: 20px;
        margin-bottom: 6px;
      }
      .foorerModal{
        background: #e7e7e7;
        margin: 0;
        padding: 20px 100px;
        position: fixed;
        left: 0;
        bottom: 0px;
        right: 0;
        z-index: 999;
        display: flex;
        align-items: space-around;
        justify-content: space-around;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BottomFooter.vue